import { DashboardOverview } from '@/components/dashboard/DashboardOverview';
import { uiStateActions } from '@/state/ui-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <DashboardOverview onAddAccount={uiStateActions.openAddAccount} />
    </>
  );
}
